import { LOGIN_SUCCESS } from './constants';

let autorState = {
    error: false,
    message: ''
};
/**
 *
 * @param state
 * @param action
 * @returns {{error: boolean, message: string}}
 */
const authorization = ( state = autorState, action ) => {
    switch ( action.type ) {
        case LOGIN_SUCCESS: {
            autorState = { ...action.status };
            return autorState;
        }
        default:
            return state;
    }
};

export { authorization as login };



